import React from 'react';
import { Section } from './ui/Section';
import { HeartIcon } from 'lucide-react';
import { Button } from './ui/Button';
export const Proof = () => {
  return <Section className="bg-terracotta/5" data-id="element-162">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-soft text-center relative overflow-hidden" data-id="element-163">
        <HeartIcon className="absolute -top-6 -right-6 text-terracotta/10 w-48 h-48" data-id="element-164" />

        <div className="relative z-10" data-id="element-165">
          <h2 className="text-2xl md:text-3xl font-serif font-medium text-charcoal mb-8 leading-relaxed" data-id="element-166">
            En solo{' '}
            <span className="text-5xl font-bold text-terracotta mx-2" data-id="element-167">
              7 días
            </span>
            , las madres que aplican el Escudo de 3 Segundos reportan una
            reducción del{' '}
            <span className="text-5xl font-bold text-terracotta mx-2" data-id="element-168">60%</span>{' '}
            en los gritos matutinos...
          </h2>

          <p className="text-xl md:text-2xl text-charcoal/80 font-light italic mb-12" data-id="element-169">
            "y, lo más importante, una desaparición casi total del sentimiento
            de culpa al acostarse."
          </p>

          <div className="flex justify-center" data-id="element-170">
            <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-171">
              ¡QUIERO MI GUÍA Y RECUPERAR MI PAZ AHORA!
            </Button>
          </div>
        </div>
      </div>
    </Section>;
};